import mitt from 'mitt'
const mitts = mitt()
export default mitts